module.exports = __webpack_public_path__ + "static/media/ic-notification-error.654cd9aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-notification-error.svg
// module id = 646
// module chunks = 14